/* angular:styles/component:css;3a88817e328d9d2c0454b0172e028bf26fc4040fcdabfb88e09ef3f6613d367b;/src/src/app/shared/components/formly/formly-radio/formly-radio.ts */
:host {
  width: 100%;
}
/*# sourceMappingURL=formly-radio.css.map */
